import { useState, useEffect } from "react";
import { loadUserSchedules } from "../state/userScheduleRepository";
import type { UserSchedule } from "../state/userScheduleRepository";

/**
 * Loads the user's personal schedules from IndexedDB.
 * Re-fetches whenever `version` increments (bumped by SCHEDULE_EDITOR_SAVED + USER_SCHEDULE_DELETED).
 * Filters out soft-deleted entries — only returns active schedules.
 */
export function useUserSchedules(version: number): UserSchedule[] {
  const [schedules, setSchedules] = useState<UserSchedule[]>([]);

  useEffect(() => {
    let cancelled = false;
    loadUserSchedules().then((all) => {
      if (!cancelled) setSchedules(all);
    });
    return () => { cancelled = true; };
  }, [version]);

  return schedules;
}
